<template>
  <a class="skip-link" href="#main-content">Skip to content</a>
  <NavbarElement v-if="$route.name !== 'connect'" />
  <main id="main-content" tabindex="-1">
    <router-view />
  </main>
  <FooterElement v-if="$route.name !== 'connect'" />
  <WhatsAppButton v-if="$route.name !== 'connect'" />
</template>

<script>
import NavbarElement from "@/components/layout/NavbarElement.vue";
import FooterElement from "@/components/layout/FooterElement.vue";
import WhatsAppButton from "@/components/layout/WhatsAppButton.vue";

export default {
  name: "App",
  components: { NavbarElement, FooterElement, WhatsAppButton },
};
</script>
